import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';

export const MastersWrapper = (props) => {
  const { children } = props;
  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        m: 0,
        p: 0,
      }}
    >
      {/* <Container
        disableGutters
        sx={{
          m: 0,
          p: 0,
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          width: '100%'
        }}
      > */}
      {children}
      {/* </Container> */}
    </Box>
  );
};

MastersWrapper.propTypes = {
  children: PropTypes.any
};
